import DataListBulkActionsContext from "@magicware/data-lists/DataListBulkActionsContext";
import { MenuAction } from "@magicware/data-lists/DataListContextMenu";
import { useTranslation } from "react-i18next";
import { useConnectorId } from "../../navigation/connectors";
import { useNewItemMenuAction } from "../../navigation/hooks";

export default function ConnectorVersionListMenuContext(props: { children?: React.ReactNode }) {
    const { t } = useTranslation();
    const actions: MenuAction[] = [];
    const connectorId = useConnectorId();
    const addAction = useNewItemMenuAction(t("add-version"), (n) => n.connectors.detail.versions.new.url(connectorId));
    return (
        <DataListBulkActionsContext defaultAction={addAction} actions={actions}>
            {props.children}
        </DataListBulkActionsContext>
    );
}
